import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
// import { getBranches } from 'Features/Shared/Locations/locationSlice';
import { getSales } from '../../Features/SalesDep/Sales/SalesSlice';
import { getBids } from '../../Features/SalesDep/Bids/BidSlice';
// import { getTemplates } from 'Features/SalesDep/Templates/TemplateSlice';
import { getCustomers } from '../../Features/Shared/Customers/CustomerSlice';
import { getAccount } from '../../Features/Shared/Account/AccountSlice';
import { getSellAThon } from '../../Features/SalesDep/Sales/SellAThonSlice';
import { getOrders } from '../../Features/SalesDep/Orders/OrderSlice';
import { getTodo } from '../../Features/SalesDep/To-Do List/TodoSlice';

export type BootstrapArgs = {
    writerId?: string | null;
    username?: string | null;
    branchId?: string | null;
}

export const salesRepViewBootstrap = createAsyncThunk<
    any,
    BootstrapArgs,
    { state: RootState }
>(
    'bootstrap/salesRepViewBootstrap',
    async (args, { dispatch, getState }) => {
        const state = getState();

        if (!state.auth.isAuthorized) return;

        await Promise.all([
            dispatch(getSales(args)).unwrap(),
            dispatch(getOrders(args)).unwrap(),
            dispatch(getBids(args)).unwrap(),
            dispatch(getCustomers(args)).unwrap(),
            dispatch(getSellAThon(args)).unwrap(),
            dispatch(getTodo(args)).unwrap(),
        ]);
    }
);

interface repViewBootstrap {
    loading: boolean;
    error: string | null;
}

const initialState: repViewBootstrap = {
    loading: false,
    error: null,
};

const salesRepViewBootstrapSlice = createSlice({
    name: 'salesRepView',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(salesRepViewBootstrap.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(salesRepViewBootstrap.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(salesRepViewBootstrap.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to bootstrap app';
            });
    },
});

export const salesRepViewBootstrapReducer = salesRepViewBootstrapSlice.reducer;